// @ts-nocheck
import clsx from "clsx";
import { useEffect, useState } from "react";
import {
	addMember,
	addTeam,
	deleteMember,
	getCustomerAccountTeam,
	getCustomerAccountTeams,
	saveMember,
} from "src/api/customer-service";
import { roles } from "src/config";
import Swal from "sweetalert2";

function Account() {
	const [teams, setTeams] = useState([]);
	const [selectedTeam, setSelectedTeam] = useState("");
	const [newTeamName, setNewTeamName] = useState("");
	const [newTeamEmail, setNewTeamEmail] = useState("");
	const [newTeamCode, setNewTeamCode] = useState("");
	const [newTeamManager, setNewTeamManager] = useState("");
	const [isAddTeamVisible, setIsAddTeamVisible] = useState(false); // State for toggling visibility
	const [newMemberCode, setNewMemberCode] = useState("");
	const [newMemberRole, setNewMemberRole] = useState(roles[0]); // Default to first role in the list

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			const customerAccountTeam = await getCustomerAccountTeams();
			setTeams(customerAccountTeam);
		} catch (error) {
			console.error("Error getting teams: ", error);
		}
	};

	const handleGetTeam = async (teamID) => {
		try {
			const customerAccountTeam = await getCustomerAccountTeam(teamID);
			setSelectedTeam(customerAccountTeam);
		} catch (error) {
			console.error("Error getting team: ", error);
		}
	};

	const handleAddMember = async () => {
		try {
			// const response = await axios.post(`${baseUri}/customer-account-team/${selectedTeam.TeamID}`, {
			//   EmployeeCode: newMemberCode,
			//   Role: newMemberRole,
			// });
			await addMember(selectedTeam.TeamID, {
				employeeCode: newMemberCode,
				role: newMemberRole,
			});

			// Clear input fields
			setNewMemberRole("");
			setNewMemberCode("");
			handleGetTeam(selectedTeam.TeamID);
		} catch (error) {
			console.error("Error adding member: ", error);
		}
	};

	const handleAddTeam = async () => {
		try {
			// const response = await axios.post(`${baseUri}/customer-account-team`, {
			//   TeamName: newTeamName,
			//   TeamEmail: newTeamEmail,
			//   TeamCode: newTeamCode,
			//   TeamManager: newTeamManager,
			// });

			await addTeam({
				teamName: newTeamName,
				teamEmail: newTeamEmail,
				teamCode: newTeamCode,
				teamManager: newTeamManager,
			});

			fetchData();
			// Clear input fields
			setNewTeamName("");
			setNewTeamEmail("");
			setNewTeamCode("");
			setNewTeamManager("");
		} catch (error) {
			console.error("Error adding team:", error);
		}
	};

	const handleMemberSave = async (teamID, member, newRole) => {
		try {
			// const response = await axios.put(`${baseUri}/customer-account-team/${teamID}/member/${member}`, {
			//   Role: newRole,
			// });

			await saveMember(teamID, member, { role: newRole });

			handleGetTeam(teamID);
		} catch (error) {
			console.error("Error saving member:", error);
		}
	};

	const handleMemberDelete = async (teamID, member) => {
		const swalResult = await Swal.fire({
			title: "Are you sure?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete!",
		});

		if (!swalResult.isConfirmed) {
			return;
		}

		try {
			// const response = await axios.delete(`${baseUri}/customer-account-team/${teamID}/member/${member}`);

			await deleteMember({ teamId: teamID, member });

			handleGetTeam(teamID);
		} catch (error) {
			console.error("Error deleting member:", error);
		}
	};

	const handleTeamSelect = (team) => {
		setSelectedTeam(team);
	};

	const handleRoleChange = (memberIndex, newRole) => {
		const updatedMembers = [...selectedTeam.Members];
		updatedMembers[memberIndex].Role = newRole;
		setSelectedTeam({ ...selectedTeam, Members: updatedMembers });
	};

	const toggleAddTeamVisibility = () => {
		setIsAddTeamVisible(!isAddTeamVisible);
	};

	const getManagerName = (members) => {
		const manager = members.find((member) => member.Role === "Manager");
		return manager ? manager.EmployeeCode : "No Manager";
	};

	return (
		<div className="p-8">
			{/* Add Team */}
			<div className="bg-gray-700 flex flex-col card">
				<div className="card-body">
					<button
						className="btn btn-primary self-center"
						onClick={toggleAddTeamVisibility}
					>
						{isAddTeamVisible ? "Hide" : "Add New Team"}
					</button>
					{isAddTeamVisible && (
						<div className="">
							<h3 className="text-white card-title">
								Add New Team
							</h3>
							<div className="text-warning mb-3">
								Notice: Teams must first be created by IT Help
								desk prior to being Imported
							</div>
							<form className="space-x-2">
								<input
									type="text"
									placeholder="Team Name"
									value={newTeamName}
									onChange={(e) =>
										setNewTeamName(e.target.value)
									}
									className="input input-bordered w-full max-w-xs input-sm"
								/>
								<input
									type="text"
									placeholder="Team Email"
									value={newTeamEmail}
									onChange={(e) =>
										setNewTeamEmail(e.target.value)
									}
									className="input input-bordered w-full max-w-xs input-sm"
								/>
								<input
									type="text"
									placeholder="Team Code"
									value={newTeamCode}
									onChange={(e) =>
										setNewTeamCode(e.target.value)
									}
									className="input input-bordered w-full max-w-xs input-sm"
								/>
								<input
									type="text"
									placeholder="Manager Code"
									value={newTeamManager}
									onChange={(e) =>
										setNewTeamManager(e.target.value)
									}
									className="input input-bordered w-full max-w-xs input-sm"
								/>
								<button
									type="button"
									onClick={handleAddTeam}
									className="btn btn-primary btn-sm"
								>
									Add Team
								</button>
							</form>
						</div>
					)}
				</div>
			</div>

			{/* Teams */}
			<div className="card card-compact bg-gray-700 mt-6">
				<div className="card-body">
					<div className="card-title text-white">Teams</div>
					<table className="table">
						<thead className="bg-gray-600 text-white">
							<tr>
								<th>Name</th>
								<th>Email</th>
								<th>Code</th>
								<th>Manager</th>
							</tr>
						</thead>
						<tbody className="text-white">
							{teams.map((team) => (
								<tr
									key={team.TeamID}
									onClick={() => handleTeamSelect(team)}
									className={clsx("cursor-pointer", {
										"bg-primary":
											team.TeamName ===
											selectedTeam.TeamName,
									})}
								>
									<td>{team.TeamName}</td>
									<td>{team.TeamEmail}</td>
									<td>{team.TeamCode}</td>
									<td>{getManagerName(team.Members)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>

			{/* Team members */}
			{selectedTeam && (
				<div className="flex mt-6 space-x-6">
					<div className="card card-compact bg-gray-700 flex-1">
						<div className="card-body">
							<div className="card-title text-white">
								Members for [{selectedTeam.TeamName}]
							</div>
							<table className="table">
								<thead className="text-white bg-gray-600">
									<tr>
										<th>UserCode</th>
										<th>Role</th>
										<th></th>
									</tr>
								</thead>
								<tbody className="text-white">
									{selectedTeam.Members.map(
										(member, index) => (
											<tr key={index}>
												<td>{member.EmployeeCode}</td>
												<td>
													<select
														className="text-gray-950 select select-bordered select-sm"
														value={member.Role}
														onChange={(e) =>
															handleRoleChange(
																index,
																e.target.value
															)
														}
													>
														{roles.map((role) => (
															<option
																key={role}
																value={role}
															>
																{role}
															</option>
														))}
													</select>
												</td>
												<td className="text-right">
													<button
														className="btn btn-success btn-sm mr-2"
														onClick={() =>
															handleMemberSave(
																selectedTeam.TeamID,
																member.EmployeeCode,
																member.Role
															)
														}
													>
														Save
													</button>
													<button
														className="btn btn-error btn-sm"
														onClick={() =>
															handleMemberDelete(
																selectedTeam.TeamID,
																member.EmployeeCode
															)
														}
													>
														Delete
													</button>
												</td>
											</tr>
										)
									)}
								</tbody>
							</table>
						</div>
					</div>

					<div className="card card-compact self-start bg-gray-700">
						<div className="card-body">
							<div className="card-title text-white">
								Add New Member
							</div>

							<fieldset className="fieldset">
								<label className="label">
									<span className="text-white">
										Employee Code
									</span>
								</label>
								<input
									type="text"
									placeholder="Employee Code"
									className="input input-bordered input-sm text-gray-950"
									value={newMemberCode}
									onChange={(e) =>
										setNewMemberCode(e.target.value)
									}
								/>
							</fieldset>

							<fieldset className="fieldset">
								<label className="label">
									<span className="text-white">
										Member Role
									</span>
								</label>
								<select
									className=" text-gray-950 select select-bordered select-sm"
									value={newMemberRole}
									onChange={(e) =>
										setNewMemberRole(e.target.value)
									}
								>
									{roles.map((role) => (
										<option key={role} value={role}>
											{role}
										</option>
									))}
								</select>
							</fieldset>
							<button
								className="mt-auto btn btn-primary"
								onClick={handleAddMember}
							>
								Add Member
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default Account;
